import { CommonModule, registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
/* ------ LANGUAGE ---------------------*/
import localeDe from '@angular/common/locales/de';
import { LOCALE_ID, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { ServiceWorkerModule } from '@angular/service-worker';
import { NgxsReduxDevtoolsPluginModule } from '@ngxs/devtools-plugin';
import { NgxsStoragePluginModule } from '@ngxs/storage-plugin';
import { NgxsModule } from '@ngxs/store';

/* ------ CORE IMPORTS -----------  */
import { CoreFrontendSharedModule, E2eNavigationModule, FeatureRouterLinkResolverService, provideAuthStrategyConfig } from '@core/frontend-shared';
import { provideRootRoutes, routerProviderFactory } from '@core/frontend-shared/router';

/* ------ COMMON IMPORTS -----------  */
import { CmsFrontendSharedModule } from '@common/cms/frontend-shared';
import { FeedbackButtonComponent } from '@common/feedback/frontend';
import { LayoutFrontendSharedModule } from '@common/layout/frontend-shared';
import { LayoutContentbarComponents } from '@common/layout/frontend-shared/contentbars';
import { LayoutRouterOutletFullscreenComponent } from '@common/layout/frontend-shared/router-outlet-fullscreen';
import { LayoutSidebarComponent, LayoutSidebarWrapperComponent } from '@common/layout/frontend-shared/sidebar';
import { LayoutToolbarComponent } from '@common/layout/frontend-shared/toolbar';
import { LocalstateFrontendSharedModule } from '@common/localstate/frontend-shared';
import { MinimalUiModule } from '@common/ui/frontend-shared';
import { UiScreenServiceModule } from '@common/ui/frontend-shared/screen-service';
import { UiTabMenuComponent } from '@common/ui/frontend-shared/tabmenu';
import { UiRequiredModule } from '@mpf/ui/frontend-shared';
import { LayoutFrontpageComponent } from '@mpf/ui/frontend-shared/layout-frontpage';
import { isE2E, NgLetDirective } from '@core/frontend-shared/utils';

/* ------ LOCAL IMPORTS -----------  */
import { AppComponent } from './components/app.component';
import { DownloadSurveyComponent } from './components/download-survey/download-survey.component';
import { LandingpageComponent } from './components/landingpage/landingpage.component';
import { AppLoginComponent } from './components/login/login.component';

import features from './features';
import { RequestDemoComponent } from './components/request-demo/request-demo.component';
import { ContactDemoRequestComponent } from '@mpf/contact/frontend-shared';
import { CoursesContinueLastCourseComponent } from '@mpf/courses/frontend-shared';
import { UserAuthenticationComponent } from '@common/users/frontend-shared';

registerLocaleData(localeDe);





 

const preloadCmsModulesForRoutes = [
	'/','/privacy','/imprint', '/terms'
]

const states: any[] = [];

const persist: string[] = ['local','language'];

const disableAnimations = isE2E();
if(disableAnimations) console.log('disabling animations due to E2E env being active')

@NgModule({
    declarations: [AppComponent],
    imports: [
        E2eNavigationModule,
        BrowserModule,
        ServiceWorkerModule.register('ngsw-worker.js?v=' + VERSION, {
            enabled: IS_PRODUCTION,
            // Register the ServiceWorker as soon as the app is stable
            // or after 30 seconds (whichever comes first).
            registrationStrategy: 'registerWhenStable:30000'
        }),
        ReactiveFormsModule,
        // must be imported BEFORE Core library!
        NgxsModule.forRoot(states, {
            developmentMode: !IS_PRODUCTION,
            selectorOptions: { suppressErrors: false }
        }),
        NgxsStoragePluginModule.forRoot({ keys: persist }),
        (!IS_PRODUCTION) ? NgxsReduxDevtoolsPluginModule.forRoot({}) : [],
        CoreFrontendSharedModule.forRoot({}),
        RouterModule.forRoot([ /* routes provided using provideRootRoutes()! */], {
            initialNavigation: 'enabledBlocking',
            paramsInheritanceStrategy: 'always',
            scrollPositionRestoration: 'top',
            // anchorScrolling: 'enabled',
        }),
        BrowserAnimationsModule.withConfig({ disableAnimations }),
		NgLetDirective,
        CmsFrontendSharedModule.forRoot({ preloadCmsModulesForRoutes }),
        LocalstateFrontendSharedModule,
        UiScreenServiceModule.forRoot(),
        MinimalUiModule.forRoot(),
        UiRequiredModule,
        UiTabMenuComponent,
        FeedbackButtonComponent,
        LayoutFrontendSharedModule.forRoot(),
        ...LayoutContentbarComponents,
        LayoutToolbarComponent,
        LayoutSidebarComponent, LayoutSidebarWrapperComponent,
        LayoutRouterOutletFullscreenComponent,
        LayoutFrontpageComponent,
        ...features,
        AppLoginComponent,
        ContactDemoRequestComponent,
        CoursesContinueLastCourseComponent,

		UserAuthenticationComponent,
        LandingpageComponent,
        DownloadSurveyComponent,
        RequestDemoComponent,
    ],
    providers: [
        { provide: APP_ID, useValue: 'mpf-frontend-ssr' },
        { provide: LOCALE_ID, useValue: "de-DE" },
        provideHttpClient(withInterceptorsFromDi(), withFetch()),
        provideClientHydration(),
        provideRootRoutes([
            { path: 'login', data: { pageTitle: 'Login/Anmeldung', layout: 'fullscreen,showBottomBar' }, component: AppLoginComponent },
            { path: 'survey', data: { pageTitle: 'Fragebogen herunterladen', layout: 'fullscreen,showBottomBar' }, component: DownloadSurveyComponent, },
            { path: 'request-demo', data: { pageTitle: 'Jetzt gratis testen!', layout: 'fullscreen,showBottomBar' }, component: RequestDemoComponent, },
            { path: '', pathMatch: 'full', component: LandingpageComponent, data: { layout: 'fullscreen,showBottomBar' } },
        ]),
        ...routerProviderFactory(),
        provideAuthStrategyConfig('credentials', {}),
        // provideAuthStrategyConfig('open-id',{}),
    ],
    bootstrap: [AppComponent],
    exports: [
        CommonModule,
        UiRequiredModule,
    ]
})
export class AppModule {
	constructor(
		test:FeatureRouterLinkResolverService,
	) {}
}
